import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const BooleanContainerWidget: WidgetRegistryEntry = {
  name: "BooleanContainer",
  configuration: () => import("./configuration").then((m) => m.BooleanContainerWidgetConfiguration),
  component: () => import("./boolean-container-widget.component").then((m) => m.BooleanContainerWidgetComponent)
};
